<template>
    <Dialog :expanderClass="'d-inline'" ref="player">
      <template #expander="{ openModal }">
    <ButtonCustomized :label="btnTitle" @click="openModal" v-if="showBtn" /> 
        <a @click="openModal" v-if="!showBtn" class="change-link" >Change </a>
  
      </template>
      <template #dialog.title>
        Select Location
      </template>
      <template #dialog.content="{ closeModal, closeModalAfter }">
  
  
        <!-- TODO (cleaner code): think about removing redundancy between "DeleteItemConfirmationForm" & other forms (e.g. CreateSlideForm) [DSP-N26Dui5A] -->
        <div>

            <SimpleEntityListingPage
    entityItemsNamePlural=""
    entityItemName="Location"
    areaAccessName="Administration"
    :ItemsLister="LocationsLister"
    :singleSelect = true 
  />

          <div class="form-buttons">
            <ButtonCustomized label="Add" @click="onSave" />
          </div>
        </div>
  
      </template>
    </Dialog>
  </template>
      
  <script lang="ts" setup>
  import Dialog from '../../../components/Dialog/Dialog.vue';
  import ButtonCustomized from "../../../components/form-fields/ButtonCustomized.vue";
  import SimpleEntityListingPage from '@/components/ListingPages/SimpleEntityListingPage/SimpleEntityListingPage.vue';
  import LocationsLister from '../../SettingsViews/LocationsListView/LocationsLister/LocationsLister.vue';
  import useListSelection from '@/components/ListingPages/ItemsLister/ItemsList/composables/listSelection';
  import { ref } from 'vue';
  const player = ref()
  const emit = defineEmits(['cancel', 'save', 'exit', 'fail'])
  defineProps({
    'showBtn':{
      type: Boolean,
      default: true
    },
    'btnTitle':{
        type: String , 
        default :'Select Location'
    }
  
  })
  const {
    selectedItemsIds,
    selectedItems,
    clearItemsSelection
  } = useListSelection({
    clearSelectionTriggerElement: document.body
  });
  
  function onExit() {
    emit('exit')
  }
  async function onSave() {
    emit('save', selectedItems[0]);
    clearItemsSelection () ;
    player.value.closeModal()
  }
  
  </script>
      
  <style lang="scss" scoped>
  .button {
    cursor: pointer;
  }
  
  .delete-item-form {
    display: flex;
    flex-direction: column;
    max-width: 30rem;
  }
  
  .form-buttons {
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;
    margin-top: 1rem;
  }
  .change-link {
    border: 0;
    cursor: pointer;
    display: inline-block;
    height: 24px;
    line-height: 24px;
    text-align: center;
    border-radius: 6px;
    text-transform: uppercase;
    color: #25294A;
    font-weight: bold;
  }
  .change-link:hover{
    text-decoration: underline;
}
  
  </style>